import { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import DatePicker from 'react-datepicker';
import ru from 'date-fns/locale/ru';

import Sidebar from '../../../components/sidebar/Sidebar';
import HeaderBtn from '../../../components/headerBtn/headerBtn';

import SectionContent from '../../../components/sectionContent/sectionContent';

import '../../../scss/App.scss';
import { IUserOptions } from '../../../types/interfaces';
import Loader from '../../../components/custom/loader/loader';
import { AppDispatch } from '../../../redux/reducer/store';
import { actionGetSimplifiedProjectsList } from '../../../redux/action/projects/actionProjects';
import {
  IAddContractInputValue,
  IEditContractInputValue,
} from '../../../types/contractsInterface';
import Select from '../../../components/custom/select/select';
import {
  actionAddCoefficient,
  actionDeleteCoefficient,
  actionEditCoefficient,
  actionGetCoefficientList,
} from '../../../redux/action/contracts/actionContracts';
import {
  actionGetServiceTypes,
  actionGetServiceTypesSelect,
} from '../../../redux/action/easymerch/actionServiceTypes';

import Checkbox from '../../../assets/images/checkbox.png';
import Delete from '../../../assets/images/delete.png';
import Edit from '../../../assets/images/edit.png';
import toast, { Toaster } from 'react-hot-toast';
import ToastPopup from '../../../components/custom/toastPopup/toastPopup';
import { generateStyles } from '../../../utils/generateToastStyles';
import { reducerSetRequestStatus } from '../../../redux/reducer/contracts/reducers/reducerCoefficientList';

const initialAddInputState = {
  project: null,
  coefficient: '',
  date: null,
};

const initialEditInputState = {
  ...initialAddInputState,
  contractId: 0,
};

const requestStatusOptions = [
  {
    status: 200,
    successMessage: 'Новый коэффициент успешно добавлен!',
  },
  {
    status: 0,
    errorMessage: 'При добавлении произошла ошибка!',
  },
  {
    status: 202,
    successMessage:
      'Файл с коэффициентами проектов успешно доблен в очередь обработки! ' +
      'Результат загрузки можно посмотреть в разделе Выгрузки - Загрузка шаблонов',
  },
  {
    status: 204,
    successMessage: 'Коэффициент успешно удален!',
  },
  {
    status: 400,
    errorMessage: 'Запись с таким проектом и периодом уже существует',
  },
  {
    status: 404,
    errorMessage: 'Запрощенный ресурс не найден',
  },
  {
    status: 'deleteError',
    errorMessage: 'При удалении произошла ошибка!',
  },
  {
    status: 'invalidCoefficient',
    errorMessage: 'Некорректное значение коэффициента',
  },
  {
    status: 'noData',
    errorMessage: 'Необходимо заполнить недостающие значения!',
  },
  {
    status: 'updateSuccess',
    successMessage: 'Данные куспешно обновлены!',
  },
  {
    status: 'updateError',
    errorMessage: 'При обновлении данных произошла ошибка!',
  },
];

const ContractsInfoSection = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams<{ id: string }>();

  const { simplifiedProjectsById, simplifiedProjectsOptions } = useSelector(
    (state: any) => state.projects.projects,
  );
  const { list, requestStatus } = useSelector(
    (state: any) => state.contracts.coefficients,
  );
  const {
    selectContactById,
    offset,
    limit: limitServiceTypes,
  } = useSelector((state: any) => state.easymerch.serviceTypes);

  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

  const actualLimit =
    JSON.parse(localStorage.getItem('pageLimit') as string) ||
    limitServiceTypes;

  const { isOpenSidebar } = useSelector(
    (state: IUserOptions) => state.user.user,
  );
  const [isPending, setIsPending] = useState<boolean>(false);

  const buttonsContainerRef = useRef<any>(null);

  const [overflowedBtnsCount] = useState<number>(0);
  const [isOpenGroupBtn] = useState<boolean>(false);

  // const [contractInputValues, setContractInputValues] =
  //   useState<IContractInputValue>({
  //     projects: [],
  //     startDate: null,
  //     endDate: null,
  //   });

  const [addContractInputValues, setAddContractInputValues] =
    useState<IAddContractInputValue>(initialAddInputState);

  const [editContractInputValues, setEditContractInputValues] =
    useState<IEditContractInputValue>(initialEditInputState);

  const [editRowId, setEditRowId] = useState<number | null>(null);

  const availableButtons = [
    {
      claims: [],
      component: (
        <HeaderBtn
          content='Вернуться к списку'
          purpose='navigateToContractsList'
          modalTitle='Возврат к списку контрактов'
        />
      ),
    },
    {
      claims: ['admin', 'contracts:budget:import'],
      component: (
        <HeaderBtn
          content='Загрузка коэффициентов бюджета'
          purpose='importCoefficients'
          modalTitle='Загрузка коэффициентов бюджета'
          selectId={getContractId()}
        />
      ),
    },
  ];

  const filteredAvailableButtons = availableButtons.filter((btn: any) => {
    return btn.claims?.length > 0
      ? btn.claims.filter((claim: any) => claims.includes(claim)).length > 0
      : true;
  });

  useEffect(() => {
    dispatch(actionGetSimplifiedProjectsList(1000, 1)).then(() => {
      setIsPending(false);
    });
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(actionGetCoefficientList(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    requestStatusOptions.forEach(
      (option: {
        status: number | string;
        successMessage?: string;
        errorMessage?: string | undefined;
      }) => {
        if (requestStatus === option.status) {
          toast.dismiss();
          toast(
            (t) => (
              <ToastPopup
                title={
                  option.successMessage
                    ? option.successMessage
                    : option.errorMessage
                }
                isSuccess={option.successMessage ? true : false}
                toast={toast}
                t={t}
              />
            ),
            generateStyles(option.successMessage ? true : false),
          );
        }
      },
    );

    setTimeout(() => {
      dispatch(reducerSetRequestStatus(null));
    }, 5000);
  }, [dispatch, requestStatus]);

  useEffect(() => {
    if (!selectContactById) {
      setIsPending(true);
      dispatch(actionGetServiceTypes(actualLimit, offset, {})).then(() => {
        setIsPending(false);
      });
      dispatch(actionGetServiceTypesSelect());
    }
  }, [selectContactById, id, dispatch, actualLimit, offset]);

  const displayedAvailableBtns = filteredAvailableButtons
    ?.slice(-(overflowedBtnsCount as number))
    ?.map((elem: any, index: number) => {
      return elem && <div key={index}>{elem?.component}</div>;
    });

  const displayedHeadBtns = filteredAvailableButtons
    ?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
    ?.map((elem: any, index: number) => {
      return elem && <div key={index}>{elem?.component}</div>;
    });

  const handleAddButton = () => {
    const testCoefficientRegexp = /^[0-9.,\s]*$/;
    if (
      !addContractInputValues.project ||
      !addContractInputValues.coefficient ||
      !addContractInputValues.date
    ) {
      dispatch(reducerSetRequestStatus('noData'));
      return false;
    }

    if (!testCoefficientRegexp.test(addContractInputValues.coefficient)) {
      dispatch(reducerSetRequestStatus('invalidCoefficient'));
      return false;
    }
    dispatch(reducerSetRequestStatus(null));
    dispatch(
      actionAddCoefficient({
        ...addContractInputValues,
        contract: id,
      }),
    );
    setAddContractInputValues(initialAddInputState);
  };

  const handleSaveButton = () => {
    dispatch(
      actionEditCoefficient({
        ...editContractInputValues,
        contract: id,
      }),
    );
    setEditRowId(null);
  };

  const handleEditRowButton = (contractId: number) => {
    setEditRowId(contractId);
    if (id) {
      const editableObject = list[id].find(
        (el: any) => el.contractBudget.id === contractId,
      );
      setEditContractInputValues({
        project: {
          value: editableObject.project.id,
          label: simplifiedProjectsById[editableObject.project.id],
        },
        coefficient: editableObject.coefficient,
        date: new Date(editableObject.year, editableObject.month - 1),
        contractId,
      });
    }
  };

  const handleCancelButton = () => {
    setEditContractInputValues(initialEditInputState);
    setEditRowId(null);
  };

  const handleDeleteButton = (contractId: number) => {
    dispatch(
      actionDeleteCoefficient({
        contractId,
        contract: id,
      }),
    );
    setEditRowId(null);
  };

  function getContractId() {
    return parseInt(id ? id : '0');
  }

  return (
    <div className='App'>
      <Sidebar />
      <SectionContent
        buttonsContainerRef={buttonsContainerRef}
        headBlockChildren={displayedHeadBtns}
        isOpenGroupBtn={isOpenGroupBtn}
        availableButtons={displayedAvailableBtns}
        title={selectContactById && id && selectContactById[id]}
        pageName='contractsInfo'
        section='Контракт'
      >
        <div className='content__main'>
          <div
            className={clsx(
              isOpenSidebar && 'btns_active',
              !isOpenSidebar && 'btns_close',
              'btns',
            )}
          >
            <Link to={`/contracts/${id}/info`} className='tab'>
              <div className='buttons__btn  --active'>Коэффициенты</div>
            </Link>
          </div>
          <div className='loader__wrapper'>
            {(false || isPending) && <Loader />}
          </div>
          {requestStatus && (
            <Toaster
              position='top-center'
              toastOptions={{
                duration: 5000,
              }}
            />
          )}
          <div className='table__wrapper'>
            <table className='flexible-table'>
              <thead>
                <tr className='clients__list_head'>
                  <th>Проект</th>
                  <th>Коэффициент</th>
                  <th>Период</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {id &&
                  list &&
                  list[id] &&
                  list[id].map((el: any) => (
                    <tr key={`${el.contractBudget.id}`}>
                      <td>
                        {editRowId === el.contractBudget.id && (
                          <Select
                            options={simplifiedProjectsOptions}
                            propsChange={(event: {
                              value: number;
                              label: string;
                            }) => {
                              setEditContractInputValues({
                                ...editContractInputValues,
                                project: {
                                  value: event.value,
                                  label: event.label,
                                },
                              });
                            }}
                            value={editContractInputValues.project}
                            placeholder='Проект'
                            name='desktop'
                            isShowPlaceholder={true}
                            className=''
                          />
                        )}

                        {editRowId !== el.contractBudget.id &&
                          simplifiedProjectsById &&
                          simplifiedProjectsById[el.project.id]}
                      </td>
                      <td>
                        {editRowId === el.contractBudget.id && (
                          <div className='filter__block'>
                            <input
                              name='addCoefficient'
                              onChange={(event) => {
                                setEditContractInputValues({
                                  ...editContractInputValues,
                                  coefficient: event.target.value,
                                });
                              }}
                              type='number'
                              value={editContractInputValues.coefficient}
                            />
                          </div>
                        )}

                        {editRowId !== el.contractBudget.id && el.coefficient}
                      </td>
                      <td>
                        {editRowId === el.contractBudget.id && (
                          <div className='filter__date-picker'>
                            <DatePicker
                              calendarClassName='filter__date-picker__calendar'
                              dateFormat='MM/yyyy'
                              locale={ru}
                              monthClassName={() =>
                                'filter__date-picker__month'
                              }
                              placeholderText='Период'
                              selected={editContractInputValues.date}
                              showMonthYearPicker
                              onChange={(date) => {
                                setEditContractInputValues({
                                  ...editContractInputValues,
                                  date,
                                });
                              }}
                            />
                          </div>
                        )}
                        {editRowId !== el.contractBudget.id &&
                          `${el.month}/${el.year}`}
                      </td>
                      {(claims.includes('admin') ||
                        claims.includes('contracts:budget:update')) && (
                        <>
                          <td>
                            {editRowId === el.contractBudget.id && (
                              <div
                                className='buttons__action'
                                onClick={handleSaveButton}
                              >
                                <img
                                  className='customers__icon'
                                  src={Checkbox}
                                  alt='Сохранить'
                                />
                                <span className='buttons__action__green'>
                                  Сохранить
                                </span>
                              </div>
                            )}

                            {editRowId !== el.contractBudget.id && (
                              <div
                                className='buttons__action'
                                onClick={() =>
                                  handleEditRowButton(el.contractBudget.id)
                                }
                              >
                                <img
                                  className='customers__icon'
                                  src={Edit}
                                  alt='Редактировать'
                                />
                                <span className='buttons__action__green'>
                                  Редактировать
                                </span>
                              </div>
                            )}
                          </td>
                          <td>
                            {editRowId === el.contractBudget.id && (
                              <div
                                className='buttons__action'
                                onClick={handleCancelButton}
                              >
                                <img
                                  className='customers__icon'
                                  src={Delete}
                                  alt='Отменить'
                                />
                                <span>Отменить</span>
                              </div>
                            )}
                            {editRowId !== el.contractBudget.id && (
                              <div
                                className='buttons__action'
                                onClick={() =>
                                  handleDeleteButton(el.contractBudget.id)
                                }
                              >
                                <img
                                  className='customers__icon'
                                  src={Delete}
                                  alt='Удалить'
                                />
                                <span>Удалить</span>
                              </div>
                            )}
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                {(claims.includes('admin') ||
                  claims.includes('contracts:budget:update')) && (
                  <tr className='table_contracts__tr'>
                    <td>
                      <div className='multiselect__filter_block'>
                        <Select
                          options={simplifiedProjectsOptions}
                          propsChange={(event: {
                            value: number;
                            label: string;
                          }) => {
                            setAddContractInputValues({
                              ...addContractInputValues,
                              project: {
                                value: event.value,
                                label: event.label,
                              },
                            });
                          }}
                          value={addContractInputValues.project}
                          placeholder='Проект'
                          className='users__filter'
                          name='desktop'
                          isShowPlaceholder={true}
                        />
                      </div>
                    </td>
                    <td>
                      <div className='filter__block filter__block--max-height'>
                        <input
                          name='addCoefficient'
                          onChange={(event) => {
                            setAddContractInputValues({
                              ...addContractInputValues,
                              coefficient: event.target.value,
                            });
                          }}
                          placeholder='Коэффициент'
                          type='number'
                          value={addContractInputValues.coefficient}
                        />
                        <label>Коэффициент</label>
                      </div>
                    </td>
                    <td>
                      <div className='filter__date-picker filter__block--max-height'>
                        <DatePicker
                          calendarClassName='filter__date-picker__calendar'
                          dateFormat='MM/yyyy'
                          locale={ru}
                          monthClassName={() => 'filter__date-picker__month'}
                          placeholderText='Период'
                          selected={addContractInputValues.date}
                          showMonthYearPicker
                          onChange={(date) => {
                            setAddContractInputValues({
                              ...addContractInputValues,
                              date,
                            });
                          }}
                        />
                      </div>
                    </td>
                    <td>
                      <button
                        onClick={handleAddButton}
                        className='table-button'
                      >
                        Добавить коэффициент
                      </button>
                    </td>
                    <td></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </SectionContent>
    </div>
  );
};

export default ContractsInfoSection;
